module.exports = __webpack_public_path__ + "img/marukoma.fad6e038.jpg";